/**
 * So Called Clothing — Policy Enhancement Script (scc-policy.js)
 * Automatically deduplicates headers, formats key facts cards,
 * promotes section headings, creates structured business entity cards,
 * highlights support channels, and enables publication-grade printing.
 */
document.addEventListener('DOMContentLoaded', function () {
  const policyContainer = document.querySelector('.shopify-policy__container');
  if (!policyContainer) return;

  const policyTitleWrap = policyContainer.querySelector('.shopify-policy__title');
  const titleH1 = policyTitleWrap ? policyTitleWrap.querySelector('h1') : null;
  const rte = policyContainer.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  const pathname = window.location.pathname.toLowerCase();

  // 1. Deduplicate H1 if present inside RTE body
  const bodyH1s = rte.querySelectorAll('h1');
  if (titleH1 && bodyH1s.length > 0) {
    const mainTitleText = titleH1.textContent.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    bodyH1s.forEach(function (h1) {
      const h1Text = h1.textContent.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
      if (h1Text === mainTitleText || h1 === rte.firstElementChild) {
        h1.classList.add('scc-duplicate-title');
        h1.style.display = 'none';
      }
    });
  }

  // 2. Add Eyebrow & Meta Bar with Print Button to Header
  if (policyTitleWrap && titleH1 && !policyTitleWrap.querySelector('.scc-policy-meta-bar')) {
    // Eyebrow
    if (!policyTitleWrap.querySelector('.scc-policy-eyebrow')) {
      const eyebrow = document.createElement('div');
      eyebrow.className = 'scc-policy-eyebrow';
      eyebrow.innerHTML = '<span class="scc-policy-eyebrow-dot"></span><span>So Called Clothing &bull; Store Policies</span>';
      policyTitleWrap.insertBefore(eyebrow, titleH1);
    }

    // Find and extract "Last updated" from body
    let lastUpdatedText = '15 August 2026';
    const allParagraphs = Array.from(rte.querySelectorAll('p, div'));
    for (let el of allParagraphs) {
      const t = el.textContent.trim();
      const match = t.match(/Last updated:\s*([A-Za-z0-9,\s]+)/i);
      if (match && t.length < 80) {
        lastUpdatedText = match[1].trim();
        el.remove();
        break;
      }
    }

    // Build Meta Bar
    const metaBar = document.createElement('div');
    metaBar.className = 'scc-policy-meta-bar';
    metaBar.innerHTML =
      '<div class="scc-policy-meta-pill">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>' +
      '<span>Last updated: ' + lastUpdatedText + '</span>' +
      '</div>' +
      '<button type="button" class="scc-policy-print-btn" aria-label="Print or save policy as PDF">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>' +
      '<span>Print / Save PDF</span>' +
      '</button>';

    policyTitleWrap.appendChild(metaBar);

    const printBtn = metaBar.querySelector('.scc-policy-print-btn');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }
  }

  // 3. Inject Print Header & Print Footer
  if (!policyContainer.querySelector('.scc-policy-print-header')) {
    const printHeader = document.createElement('div');
    printHeader.className = 'scc-policy-print-header';
    printHeader.setAttribute('aria-hidden', 'true');
    printHeader.innerHTML =
      '<div class="scc-policy-print-brand">SO CALLED CLOTHING</div>' +
      '<div class="scc-policy-print-meta">Official Store Policy Document &bull; https://socalledclothing.com &bull; GSTIN: 07CQNPB2742K1ZQ</div>';
    policyContainer.insertBefore(printHeader, policyContainer.firstChild);
  }

  if (!policyContainer.querySelector('.scc-policy-print-footer')) {
    const printFooter = document.createElement('div');
    printFooter.className = 'scc-policy-print-footer';
    printFooter.setAttribute('aria-hidden', 'true');
    printFooter.innerHTML =
      '<div>So Called Clothing &bull; Graphic Streetwear &bull; GSTIN: 07CQNPB2742K1ZQ &bull; Correspondence: Third Floor, House No. 170, KH No. 393, Vill. Ghitorni, New Delhi 110030</div>' +
      '<div>Direct Support: support@socalledclothing.com &bull; WhatsApp: +91 81686 04060 &bull; Web: https://socalledclothing.com</div>';
    policyContainer.appendChild(printFooter);
  }

  // 4. Refund Policy Key Facts & Headings
  if (pathname.includes('refund-policy')) {
    const pEls = Array.from(rte.querySelectorAll('p'));
    let windowP = null, conditionP = null, timelineP = null;

    pEls.forEach(function (p) {
      const text = p.textContent.trim().toLowerCase();
      if (text.startsWith('return window:')) windowP = p;
      if (text.startsWith('item condition:')) conditionP = p;
      if (text.startsWith('refund timeline:')) timelineP = p;
    });

    if (windowP || conditionP || timelineP) {
      const factsGrid = document.createElement('div');
      factsGrid.className = 'scc-policy-key-facts';
      factsGrid.innerHTML =
        '<div class="scc-policy-fact-card">' +
        '<div class="scc-policy-fact-val">7 Days</div>' +
        '<div class="scc-policy-fact-title">Return & Exchange Window</div>' +
        '<p class="scc-policy-fact-desc">Submit your return or size exchange request within 7 calendar days of delivery.</p>' +
        '</div>' +
        '<div class="scc-policy-fact-card">' +
        '<div class="scc-policy-fact-val">Pristine</div>' +
        '<div class="scc-policy-fact-title">Item Condition</div>' +
        '<p class="scc-policy-fact-desc">Unused, unwashed, perfume-free with all original tags and packaging intact.</p>' +
        '</div>' +
        '<div class="scc-policy-fact-card">' +
        '<div class="scc-policy-fact-val">5–7 Days</div>' +
        '<div class="scc-policy-fact-title">Refund Processing</div>' +
        '<p class="scc-policy-fact-desc">Processed to original payment or UPI/bank transfer after passing quality inspection.</p>' +
        '</div>';

      const insertTarget = windowP || conditionP || timelineP;
      insertTarget.parentNode.insertBefore(factsGrid, insertTarget);

      if (windowP) windowP.remove();
      if (conditionP) conditionP.remove();
      if (timelineP) timelineP.remove();
    }
  }

  // 5. Shipping Policy Key Facts & Section Promotion
  if (pathname.includes('shipping-policy')) {
    if (!rte.querySelector('.scc-policy-key-facts')) {
      const factsGrid = document.createElement('div');
      factsGrid.className = 'scc-policy-key-facts';
      factsGrid.innerHTML =
        '<div class="scc-policy-fact-card">' +
        '<div class="scc-policy-fact-val">₹79 / Free</div>' +
        '<div class="scc-policy-fact-title">Shipping Charges</div>' +
        '<p class="scc-policy-fact-desc">Free standard delivery on orders ₹1,499+. Flat ₹79 for orders below ₹1,499.</p>' +
        '</div>' +
        '<div class="scc-policy-fact-card">' +
        '<div class="scc-policy-fact-val">5–7 Days</div>' +
        '<div class="scc-policy-fact-title">Estimated Delivery</div>' +
        '<p class="scc-policy-fact-desc">Reliable courier dispatch across all serviceable pin codes throughout India.</p>' +
        '</div>' +
        '<div class="scc-policy-fact-card">' +
        '<div class="scc-policy-fact-val">Live Tracking</div>' +
        '<div class="scc-policy-fact-title">Order Updates</div>' +
        '<p class="scc-policy-fact-desc">Instant real-time tracking links dispatched via SMS and order confirmation email.</p>' +
        '</div>';

      rte.insertBefore(factsGrid, rte.firstChild);
    }
  }

  // 6. Promote raw paragraphs that act as headings
  const knownHeadingTexts = [
    'shipping charges',
    'delivery timeframe',
    'order and tracking updates',
    'address changes'
  ];

  const allPElements = Array.from(rte.querySelectorAll('p'));
  allPElements.forEach(function (p) {
    const rawText = p.textContent.trim();
    const lowerText = rawText.toLowerCase();

    // Check for known plain headings
    if (knownHeadingTexts.includes(lowerText)) {
      const h2 = document.createElement('h2');
      h2.className = 'scc-policy-promoted-heading';
      h2.textContent = rawText;
      p.parentNode.replaceChild(h2, p);
      return;
    }

    // Check for numbered sections like "1. Seven-day return policy"
    const numMatch = rawText.match(/^(\d+)\.\s+(.*)$/);
    if (numMatch && rawText.length < 60) {
      const numStr = numMatch[1].padStart(2, '0');
      const titleStr = numMatch[2];
      const h2 = document.createElement('h2');
      h2.className = 'scc-policy-promoted-heading';
      h2.innerHTML = '<span class="scc-policy-sec-badge">' + numStr + '</span><span>' + titleStr + '</span>';
      p.parentNode.replaceChild(h2, p);
    }
  });

  // Also style existing H2 elements with numbers if present (e.g. Terms of Service)
  const existingH2s = Array.from(rte.querySelectorAll('h2:not(.scc-policy-promoted-heading)'));
  existingH2s.forEach(function (h2) {
    const rawText = h2.textContent.trim();
    const numMatch = rawText.match(/^(\d+)\.\s+(.*)$/);
    if (numMatch) {
      const numStr = numMatch[1].padStart(2, '0');
      const titleStr = numMatch[2];
      h2.innerHTML = '<span class="scc-policy-sec-badge">' + numStr + '</span><span>' + titleStr + '</span>';
    }
  });

  // 7. Format Contact / Legal Notice Business Entity Cards
  if (pathname.includes('contact-information') || pathname.includes('legal-notice')) {
    // Fix concatenated "Email: support@socalledclothing.comWhatsApp: +91 81686 04060"
    const textPs = Array.from(rte.querySelectorAll('p'));
    textPs.forEach(function (p) {
      if (p.textContent.includes('support@socalledclothing.comWhatsApp:')) {
        p.innerHTML =
          'Email: <a href="mailto:support@socalledclothing.com" class="scc-policy-email-highlight">' +
          '<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>' +
          'support@socalledclothing.com</a>' +
          '&nbsp;&nbsp;&bull;&nbsp;&nbsp;' +
          'WhatsApp: <a href="https://wa.me/918168604060" target="_blank" rel="noopener" class="scc-policy-whatsapp-highlight">' +
          '<svg viewBox="0 0 24 24"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2z"/></svg>' +
          '+91 81686 04060</a>';
      }
    });

    // Build structured Entity Card
    const gstMatch = Array.from(rte.querySelectorAll('p')).find(p => p.textContent.includes('07CQNPB2742K1ZQ'));
    if (gstMatch && !rte.querySelector('.scc-policy-entity-card')) {
      const entityCard = document.createElement('div');
      entityCard.className = 'scc-policy-entity-card';
      entityCard.innerHTML =
        '<div class="scc-policy-entity-header">' +
        '<div class="scc-policy-entity-title">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>' +
        '<span>Official Business Registration</span>' +
        '</div>' +
        '<span class="scc-policy-verified-tag">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
        'Verified Merchant</span>' +
        '</div>' +
        '<div class="scc-policy-entity-grid">' +
        '<div>' +
        '<div class="scc-policy-entity-item-label">Legal Entity</div>' +
        '<div class="scc-policy-entity-item-val">So Called Clothing (Sole Proprietorship)</div>' +
        '</div>' +
        '<div>' +
        '<div class="scc-policy-entity-item-label">Proprietor</div>' +
        '<div class="scc-policy-entity-item-val">Aakash Bhardwaj</div>' +
        '</div>' +
        '<div>' +
        '<div class="scc-policy-entity-item-label">GST Identification Number</div>' +
        '<div class="scc-policy-entity-item-val" style="font-family: monospace; letter-spacing: 0.05em; font-size: 0.96rem;">07CQNPB2742K1ZQ</div>' +
        '</div>' +
        '<div>' +
        '<div class="scc-policy-entity-item-label">Correspondence Address</div>' +
        '<div class="scc-policy-entity-item-val">Third Floor, House No. 170, KH No. 393, G/F, L/S, Vill. Ghitorni, Near 100 Feet Road, New Delhi 110030, India</div>' +
        '</div>' +
        '</div>';

      gstMatch.parentNode.insertBefore(entityCard, gstMatch);

      // Clean up raw duplicate paragraphs now elegantly represented in the entity card
      textPs.forEach(function (p) {
        const t = p.textContent.trim();
        if (
          t.includes('07CQNPB2742K1ZQ') ||
          t.includes('Third Floor, House No. 170') ||
          t.includes('sole proprietorship owned by Aakash Bhardwaj')
        ) {
          p.remove();
        }
      });
    }
  }

  // 8. Wrap Delays or Delivery Inquiries as Support Card
  const paragraphs = Array.from(rte.querySelectorAll('p, h2, h3'));
  paragraphs.forEach(function (el) {
    const text = el.textContent.trim();
    if (text.toLowerCase().includes('delays or delivery issues') || text.toLowerCase().includes('delays or delivery inquiries')) {
      let nextP = el.nextElementSibling;
      while (nextP && nextP.tagName === 'P' && nextP.textContent.trim() === '') {
        nextP = nextP.nextElementSibling;
      }

      if (nextP && nextP.textContent.toLowerCase().includes('support@socalledclothing.com')) {
        const card = document.createElement('div');
        card.className = 'scc-policy-support-card';
        card.innerHTML =
          '<div class="scc-policy-support-card__title">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>' +
          '<span>Delays or Delivery Inquiries</span>' +
          '</div>' +
          '<div class="scc-policy-support-card__body">' +
          nextP.innerHTML.replace(
            /support@socalledclothing\.com/gi,
            '<a href="mailto:support@socalledclothing.com" class="scc-policy-email-highlight">' +
            '<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>' +
            'support@socalledclothing.com' +
            '</a>'
          ) +
          '</div>';

        el.parentNode.insertBefore(card, el);
        el.remove();
        nextP.remove();
      }
    }
  });

  // 9. Highlight remaining unlinked support email addresses
  const emailWalker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT, null, false);
  const emailNodes = [];
  let emailNode;
  while ((emailNode = emailWalker.nextNode())) {
    if (
      emailNode.nodeValue.includes('support@socalledclothing.com') &&
      emailNode.parentElement &&
      emailNode.parentElement.tagName !== 'A' &&
      !emailNode.parentElement.closest('.scc-policy-support-card') &&
      !emailNode.parentElement.closest('.scc-policy-entity-card')
    ) {
      emailNodes.push(emailNode);
    }
  }

  emailNodes.forEach(function (textNode) {
    const parent = textNode.parentNode;
    if (!parent) return;
    const parts = textNode.nodeValue.split('support@socalledclothing.com');
    const fragment = document.createDocumentFragment();

    parts.forEach(function (part, idx) {
      if (part) fragment.appendChild(document.createTextNode(part));
      if (idx < parts.length - 1) {
        const link = document.createElement('a');
        link.href = 'mailto:support@socalledclothing.com';
        link.className = 'scc-policy-email-highlight';
        link.innerHTML =
          '<svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>' +
          'support@socalledclothing.com';
        fragment.appendChild(link);
      }
    });

    parent.replaceChild(fragment, textNode);
  });

  // 10. Highlight WhatsApp phone numbers across policy body
  const waWalker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT, null, false);
  const waNodes = [];
  let waNode;
  while ((waNode = waWalker.nextNode())) {
    if (
      (waNode.nodeValue.includes('+91 81686 04060') || waNode.nodeValue.includes('81686 04060')) &&
      waNode.parentElement &&
      waNode.parentElement.tagName !== 'A' &&
      !waNode.parentElement.closest('.scc-policy-entity-card')
    ) {
      waNodes.push(waNode);
    }
  }

  waNodes.forEach(function (textNode) {
    const parent = textNode.parentNode;
    if (!parent) return;
    const regex = /(\+91\s*81686\s*04060|81686\s*04060)/g;
    const rawVal = textNode.nodeValue;
    const parts = rawVal.split(regex);
    const fragment = document.createDocumentFragment();

    parts.forEach(function (part) {
      if (!part) return;
      if (part.match(regex)) {
        const link = document.createElement('a');
        link.href = 'https://wa.me/918168604060';
        link.target = '_blank';
        link.rel = 'noopener';
        link.className = 'scc-policy-whatsapp-highlight';
        link.innerHTML =
          '<svg viewBox="0 0 24 24"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2z"/></svg>' +
          '+91 81686 04060';
        fragment.appendChild(link);
      } else {
        fragment.appendChild(document.createTextNode(part));
      }
    });

    parent.replaceChild(fragment, textNode);
  });
});
